import React from "react";
import LegalShell, { Section } from "@/pages/legal/LegalShell";

const UPDATED = "16 January 2026";

export default function Refund() {
  return (
    <LegalShell eyebrow="§ Legal · 03" title={<>Refund <span className="saffron">Policy.</span></>} updated={UPDATED}>
      <p>
        This Refund Policy applies to all paid digital services purchased on the Forte² Space platform,
        operated by <strong className="text-white">Gritly Analytics Private Limited</strong> (&quot;Company&quot;).
        By purchasing any service, you accept this Policy.
      </p>

      <Section n="1" title="No-Refund Policy">
        <p>All purchases of digital services on the Platform — including but not limited to Forte² Score
        premium reports, cohort programmes, learning pathways, mentorship credits and marketplace listings —
        are <strong className="text-white">final, non-refundable and non-transferable</strong>, save as
        expressly provided below or as required by applicable law of India.</p>
        <p>The reason: digital services are delivered instantly and consumed on access. Once the report is
        generated, the cohort access is provisioned or a mentor slot is booked, the service cannot be
        &quot;returned&quot;.</p>
      </Section>

      <Section n="2" title="Currency &amp; Cross-Border">
        <p>All transactions are processed in Indian Rupees (INR) inclusive of applicable GST.
        <strong className="text-white"> We do not accept cross-border payments </strong>at this time. If a
        payment initiated from outside India is processed in error, the amount will be refunded to the source
        account after deduction of gateway charges.</p>
      </Section>

      <Section n="3" title="Exceptions">
        <p>A refund may be considered, at the sole discretion of the Company, in the following limited cases:</p>
        <ul className="list-disc pl-6 space-y-1">
          <li>Duplicate payment for the same service.</li>
          <li>Failed transaction where the service was not provisioned but the amount was debited.</li>
          <li>Verified technical failure originating from the Platform preventing service delivery.</li>
        </ul>
        <p>Refunds under these exceptions will be processed to the original payment method within{" "}
        <strong className="text-white">7–10 business days</strong> of approval.</p>
      </Section>

      <Section n="4" title="How to Request a Refund (in the above cases only)">
        <ol className="list-decimal pl-6 space-y-1">
          <li>Email <span className="saffron">[email protected]</span> with subject &quot;Refund Request&quot;.</li>
          <li>Include your order ID, registered email, payment date and reason.</li>
          <li>We will acknowledge within 2 business days and resolve within 15 days.</li>
        </ol>
      </Section>

      <Section n="5" title="Chargebacks">
        <p>If a chargeback is initiated with your card issuer for a validly delivered service, we reserve the
        right to (a) contest the chargeback with evidence of service delivery and (b) suspend your account
        until the dispute is resolved.</p>
      </Section>

      <Section n="6" title="Governing Law &amp; Jurisdiction">
        <p>This Refund Policy is governed by the laws of India. Courts at <strong className="text-white">
        Chennai, Tamil Nadu</strong> shall have exclusive jurisdiction over any disputes.</p>
      </Section>

      <Section n="7" title="Contact">
        <p>For any refund-related question, write to <span className="saffron">[email protected]</span>.</p>
      </Section>
    </LegalShell>
  );
}
